var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:['e-status-link', ("e-status-link--" + _vm.status)],attrs:{"to":_vm.to}},[_c('span',{class:[_vm.icon]})])}
var staticRenderFns = []

export { render, staticRenderFns }